var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreenTickIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 8,
    fill: "#D0F2E2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.2149 6.38279C11.3555 6.52337 11.3555 6.75131 11.2149 6.8919L7.85487 10.2519C7.71428 10.3925 7.48634 10.3925 7.34575 10.2519L5.42575 8.3319C5.28517 8.19131 5.28517 7.96337 5.42575 7.82279C5.56634 7.6822 5.79428 7.6822 5.93487 7.82279L7.60031 9.48823L10.7058 6.38279C10.8463 6.2422 11.0743 6.2422 11.2149 6.38279Z",
    fill: "#496959"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenTickIcon);
export default __webpack_public_path__ + "static/media/greenTickIcon.7c74471669f270c82d18b14267fdd75f.svg";
export { ForwardRef as ReactComponent };